import { render } from "./Default-Footer.vue?vue&type=template&id=70a15131"
import script from "./Default-Footer.vue?vue&type=script&lang=js"
export * from "./Default-Footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__